import React, { Component } from 'react'
import { Row, Alert, CloseButton } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { observable, makeObservable, action } from 'mobx'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { colors } from '../../styles/colors'
import { DeleteIcon } from '../Icons/DeleteIcon'
import { PenIcon } from '../Icons/PenIcon'

const RIGHT_COLS = '100px 100px;'
const RIGHT_GAP = '14px'
const RIGHT_PADDING_X = 12

const PositionCard = styled.div`
  background: #fff;
  border: 1px solid ${colors.gray3};
  border-radius: 10px;
  margin: 14px 0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`
const PositionHeaderStrip = styled.div`
  display: grid;
  grid-template-columns: 1fr 520px;
  align-items: center;

  padding: 14px 16px;
  background: #efeff1;
  border-bottom: 1px solid ${colors.gray3};
  column-gap: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    row-gap: 8px;
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr 1.2fr;
  }
`

const HeaderLeftTitle = styled.div`
  font-size: 1.15rem;
`

const HeaderRightLabels = styled.div`
  padding: 0 ${RIGHT_PADDING_X}px;

  display: grid;
  grid-template-columns: ${RIGHT_COLS};
  gap: ${RIGHT_GAP};
  align-items: center;
  justify-items: center;

  @media (max-width: 992px) {
    padding: 0;
    grid-template-columns: 1fr 1fr;
    gap: 8px 14px;
  }
  @media (max-width: 992px) {
    display: none;
  }
`

const HeaderLabel = styled.div`
  font-weight: 700;
  // color: ${colors.gray2};
`

const PositionTopRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;

  gap: 16px;
  padding: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`

const TopLeft = styled.div`
  min-width: 0;
  flex: 1;
`

const ArticleName = styled.div`
  font-size: 1.2rem;
  line-height: 1.2;
  word-break: break-word;
`

const ArticleNr = styled.div`
  margin-top: 6px;
  color: #2f2f2f; /* darker like screenshot */
  font-size: 1rem;
`
const TopRightValues = styled.div`
  background: #fff;
`

const TopRightInner = styled.div`
  padding: 0 ${RIGHT_PADDING_X}px;

  @media (max-width: 992px) {
    padding: 0;
  }
`

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: ${RIGHT_COLS};
  gap: ${RIGHT_GAP};
  align-items: center;
  justify-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`

const ValueCell = styled.div`
  min-width: 0;

  .valueControl {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    min-width: 180px;
  }

  @media (max-width: 992px) {
    .valueControl {
      min-width: 160px;
    }
  }

  @media (min-width: 993px) {
    .valueControl {
      min-width: unset;
    }
  }

  input {
    max-width: 110px;
  }
`
const ContentArea = styled.div`
  padding: 10px 16px 16px 16px;
`
const MobileLabel = styled.div`
  display: none;
  font-weight: 700;
  font-size: 0.9rem;

  @media (max-width: 992px) {
    display: block;
  }
`

const MobileRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (max-width: 992px) {
    width: 100%;
  }
`

class ScanListItem extends Component {
  enforceUpdate = false
  timeout = null
  constructor(props) {
    super(props)
    makeObservable(this, {
      enforceUpdate: observable,
      timeout: observable,
      initTimeOut: action
    })
    this.initTimeOut();
  }
  initTimeOut = () => {
    const { washStore } = this.props
    const hideScanAfterTime = washStore.getHideScanAfterTime()*1000;
    if (!hideScanAfterTime) {
      return true;
    }
    this.timeout = setTimeout(() => {
      const { position, handleDeletePosition } = this.props
      handleDeletePosition(position.scanId)
    }, hideScanAfterTime)
  }
  onClickRemove = async (e) => {
    const { position, handleDeletePosition } = this.props
    e.preventDefault()
    handleDeletePosition(position.scanId)
  }
  onClickEdit = async (e) => {
    const { position, handleEditPosition } = this.props
    e.preventDefault()
    this.enforceUpdate = true;
    clearTimeout(this.timeout)
    handleEditPosition(position.scanId)
  }
  onClickDispose = async (e) => {
    const { position, handleDisposedPosition } = this.props
    e.preventDefault()
    this.enforceUpdate = true;
    clearTimeout(this.timeout)
    handleDisposedPosition(position.scanId)
  }
  renderActionButtons() {
    const { t , washStore} = this.props
    return (
      <>
        <Row>
          <span
            role='button'
            onClick={this.onClickEdit}
            tabIndex={-1}
          >
            <PenIcon title={t('edit')} />
          </span>
        </Row>
        {washStore.checkWashActionIsAllowed('disposed') && <Row>
          <span
            role='button'
            onClick={this.onClickDispose}
            tabIndex={-1}
          >
            <DeleteIcon title={t('washPage:discardArticle')} />
          </span>
        </Row>}
      </>
    )
  }
  renderListItem() {
    const { t, position, washStore } = this.props
    const { article, articleVariant, businesspartner, office, costcenter } = position
    const validationError = washStore.createErrorCode(position)
    const validationInfo = washStore.createInfoCode(position)
    return (
      <React.Fragment>
        <PositionCard>
          <div style={{ background: "#efeff1" /*, padding: "2px 2px"*/ }} className="d-flex justify-content-end">
            <CloseButton onClick={this.onClickRemove} />
          </div>
          <PositionHeaderStrip>
            <HeaderLeftTitle>
              {t('inventory:scanCode')}: {position.rfid}
            </HeaderLeftTitle>{' '}
            <HeaderRightLabels>
              <HeaderLabel>
                {/*t('inventory:washProcess')}/{t('inventory:washCycles')*/}
              </HeaderLabel>
              <HeaderLabel>
                {/*t('returnsProcessingPage:actionToPerform')*/}
              </HeaderLabel>
            </HeaderRightLabels>
          </PositionHeaderStrip>
          <PositionTopRow>
            <TopLeft>
              <ArticleName>{article.displayName}</ArticleName>
              <ArticleNr>
                {t('productDetail:articleNumber')}: {article.articleNumber}, {t('size')}: {articleVariant?.displayName ?? '---'}
                <div>{t('washPage:bearer')}: {businesspartner?.displayName}, {t('orgaUnit')}: {office?.displayName}, {t('costcenter')}: {costcenter?.displayName}</div>
              </ArticleNr>
            </TopLeft>
            <TopRightValues>
              <TopRightInner>
                <ValuesGrid>
                  <ValueCell>
                    <MobileRow>
                      <MobileLabel>
                        {t('inventory:washProcess')}{!!position.washCycles && `/${t('inventory:washCycles')}`}
                      </MobileLabel>
                      <div className='valueControl'>
                        <div>{position.washCounter ?? '0'}{!!position.washCycles && `/${position.washCycles}`}</div>
                      </div>
                    </MobileRow>
                  </ValueCell>
                  <ValueCell>
                    <MobileRow>
                      {this.renderActionButtons()}
                    </MobileRow>
                  </ValueCell>
                </ValuesGrid>
              </TopRightInner>
            </TopRightValues>
          </PositionTopRow>
          <ContentArea>
            {validationError && (
              <Alert variant='danger' className='mb-3'>
                {validationError}
              </Alert>
            )}
            {validationInfo && (
              <Alert variant='info' className='mb-3'>
                {validationInfo}
              </Alert>
            )}
          </ContentArea>
        </PositionCard>
      </React.Fragment>
    )
  }

  render() {
    return <>{this.renderListItem()}</>
  }
}
export default withTranslation()(inject('washStore')(observer(ScanListItem)))
